var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Button, Chip, Grid, TextField, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { appointmentRescheduleAPI, getAppointmnetSlotsUrl, getSlotAPI } from "../../api/url";
import { MuiStack } from "../../components";
import SkeletonLoader from "../../components/atoms/sketeton";
import CalendarComponent from "../../components/molecules/calendarComponent";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { showLoader, showNotification } from "../../redux/commonSlice";
import { createAPI, getListAPI, setState, updateAPI } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { getSlotDisable, getTime, GoogleAnlyticsErrorLog, handleServerSideErrors, handleServerSideErrorsForAnalytics } from "../../utils/utils";
export default function RescheduleAppointmentModal(props) {
    var _this = this;
    var onReschedulePopup = props.onReschedulePopup, data = props.data, appointmentId = props.appointmentId;
    var id = useParams().id;
    var _a = useState(), dateValue = _a[0], setDateValue = _a[1];
    var _b = useState([]), timeSlotData = _b[0], setTimeSlotData = _b[1];
    var _c = useState([]), selectedTimeSlot = _c[0], setSelectedTimeSlot = _c[1];
    var _d = useState(false), isSkeleton = _d[0], setIsSkeleton = _d[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _e = useState(""), rejectRemark = _e[0], setRejectRemark = _e[1];
    var _f = useState([]), getCurrentCalendarData = _f[0], setCurrentCalendarData = _f[1];
    var _g = useState(null), fullDate = _g[0], setFullDate = _g[1];
    var _h = useState(), maxSlotValue = _h[0], setMaxSlotValue = _h[1];
    var _j = useState(false), slotsLoading = _j[0], setSlotLoading = _j[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var fromDate = new Date(moment().startOf('day').toString()).toISOString();
    var toDate = new Date(moment().add(30, 'days').startOf('day').toString()).toISOString();
    useEffect(function () {
        getSlotStatsByDay();
    }, []);
    function getSlotFormattedData(slots) {
        var toDate = moment().add(30, 'days').startOf('day');
        var datePointer = moment().startOf('day');
        var resultArray = [];
        var maxCount = 0;
        while (datePointer.isSameOrBefore(toDate)) {
            var slotItem = slots.find(function (item) { return datePointer.isSame(item.Day); });
            var TotalSlots = slotItem && slotItem.TotalCount ? slotItem.TotalCount : 25;
            maxCount = TotalSlots > maxCount ? Number(TotalSlots) : Number(maxCount);
            resultArray.push({
                WeekdayShort: datePointer.format('ddd'),
                Month: datePointer.month('MM'),
                Date: datePointer.format('DD'),
                Year: datePointer.format('YYYY'),
                AvailableSlots: slotItem && slotItem.AvailableCount ? slotItem.AvailableCount : 0,
                FullDate: datePointer.toISOString(),
                TotalSlots: TotalSlots
            });
            datePointer = datePointer.add(1, 'days');
        }
        setMaxSlotValue(maxCount);
        return resultArray;
    }
    function getSlotStatsByDay() {
        var OrganizationId = selectedBranch && selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId ? selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId : "";
        var request = {
            "FromDate": fromDate,
            "ToDate": toDate,
            "OrganizationId": OrganizationId
        };
        setSlotLoading(true);
        dispatch(createAPI({
            key: "",
            url: getAppointmnetSlotsUrl,
            request: request
        })).then(function (result) {
            var apiResult = result === null || result === void 0 ? void 0 : result.payload;
            if (apiResult.data && apiResult.data.length > 0 && apiResult.success) {
                var slots = apiResult === null || apiResult === void 0 ? void 0 : apiResult.data;
                var availableSlots = getSlotFormattedData(slots);
                setCurrentCalendarData(availableSlots);
            }
        }).catch(function (err) {
            console.error("Create :: ", err);
        }).finally(function () {
            setSlotLoading(false);
        });
    }
    var onCalendarDateClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, date, ISOFormatDate, result, request, _result$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    date = new Date(e);
                    setIsSkeleton(true);
                    setDateValue(e);
                    setTimeSlotData([]);
                    setSelectedTimeSlot("");
                    ISOFormatDate = date.toISOString();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "getSlotDetails",
                            url: getSlotAPI,
                            request: {
                                OrganizationId: data === null || data === void 0 ? void 0 : data.OrganizationId,
                                Date: ISOFormatDate // date format issue
                            }
                        }))];
                case 2:
                    result = _a.sent();
                    request = {
                        OrganizationId: data === null || data === void 0 ? void 0 : data.OrganizationId,
                        Date: ISOFormatDate // date format issue
                    };
                    if (!((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.value) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    setTimeSlotData(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                    setSelectedTimeSlot("");
                    setIsSkeleton(false);
                    return [3 /*break*/, 5];
                case 4:
                    setSelectedTimeSlot("");
                    setTimeSlotData([]);
                    setIsSkeleton(false);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onClickOfSlotBar = function (item) {
        setFullDate(item.FullDate);
        onCalendarDateClick(new Date(item.FullDate));
    };
    var onTimeSlotSelectedClick = function (item) {
        setSelectedTimeSlot(item);
    };
    var onRescheduledClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var _Result$payload, _Result$payload2, request, Result, profileData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        ScheduledDate: dateValue ? dateValue.toISOString() : null,
                        Date: dateValue ? dateValue.toISOString() : null,
                        SlotId: selectedTimeSlot !== null && selectedTimeSlot !== void 0 && selectedTimeSlot.SlotId ? selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.SlotId : null,
                        StartTime: selectedTimeSlot !== null && selectedTimeSlot !== void 0 && selectedTimeSlot.StartTime ? selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.StartTime : null
                    };
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: "appointmentReschedule",
                            url: appointmentRescheduleAPI + "".concat(id ? id : appointmentId, "/RescheduleAppointment"),
                            request: request
                        }))];
                case 1:
                    Result = _a.sent();
                    if ((Result === null || Result === void 0 || (_Result$payload = Result.payload) === null || _Result$payload === void 0 ? void 0 : _Result$payload.statusCode) == 200 || Result !== null && Result !== void 0 && (_Result$payload2 = Result.payload) !== null && _Result$payload2 !== void 0 && _Result$payload2.success) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Rescheduled successfully",
                            type: "success"
                        }));
                        onReschedulePopup(false);
                        dispatch(setState({
                            key: "menuValue",
                            value: 'rescheduled'
                        }));
                        navigate("/appointment");
                    }
                    else {
                        profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', handleServerSideErrorsForAnalytics(Result === null || Result === void 0 ? void 0 : Result.error));
                        dispatch(showNotification({
                            isOpen: true,
                            message: handleServerSideErrors(Result === null || Result === void 0 ? void 0 : Result.error),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        onReschedulePopup(false);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.log("Error-", e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onArrowDateChange = function (string) {
        if (fullDate) {
            var day = new Date(fullDate);
            if (moment(fullDate).isSameOrBefore(toDate)) {
                if (string === 'next' && !moment(fullDate).isSame(toDate)) {
                    var nextDay = new Date(day);
                    nextDay.setDate(day.getDate() + 1);
                    onCalendarDateClick(new Date(nextDay));
                    // nextDay = dateFormate(nextDay, true)
                    setFullDate(nextDay);
                }
                else if (string === 'prev') {
                    var prevDay = new Date(day);
                    prevDay.setDate(day.getDate() - 1);
                    // prevDay = dateFormate(prevDay, true)
                    onCalendarDateClick(new Date(prevDay));
                    setFullDate(prevDay);
                }
            }
            else {
                setFullDate(toDate);
            }
        }
    };
    var handleChangeRejectRemark = function (e) {
        var _e$target;
        setRejectRemark((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        id: "reschedule-appointment-popup",
        flexDirection: "column",
        gap: 2
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "reschedule-popup",
        fontSize: "xl",
        fontWeight: "strong"
    }, t("Reschedule appointment")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "normal",
        color: "textSecondary"
    }, t("Please select new date and time slot for your appointment"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Box, {
        paddingBottom: selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId && getCurrentCalendarData && Array.isArray(getCurrentCalendarData) && getCurrentCalendarData.length > 0 ? 6 : 0
    }, slotsLoading ? /*#__PURE__*/ React.createElement(MuiStack, {
        height: 100,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId && getCurrentCalendarData && Array.isArray(getCurrentCalendarData) && getCurrentCalendarData.length > 0 ? /*#__PURE__*/ React.createElement(CalendarComponent, {
        getCurrentCalendarData: getCurrentCalendarData,
        fullDate: fullDate,
        onArrowDateChange: function (value) { return onArrowDateChange(value); },
        maxSlotValue: maxSlotValue
        // dateFormate={(value: any) => dateFormate(value)}
        ,
        onClickOfSlotBar: function (data) { return onClickOfSlotBar(data); },
        selectedTimeSlot: selectedTimeSlot
    }) : /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, 'No slots available.'))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: "space-between",
        spacing: 1,
        mt: 2
    }, (timeSlotData === null || timeSlotData === void 0 ? void 0 : timeSlotData.length) > 0 ? timeSlotData === null || timeSlotData === void 0 ? void 0 : timeSlotData.map(function (value) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "timeSlots",
        disabled: getSlotDisable(value.EndTime, value.Day, value.AvailabilityCount),
        color: (selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.StartTime) == value.StartTime ? 'primary' : 'secondary',
        variant: (selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.StartTime) == value.StartTime ? 'contained' : 'outlined',
        fullWidth: true,
        onClick: function () {
            onTimeSlotSelectedClick(value);
        },
        sx: {
            fontSize: 'sm'
        }
    }, getTime(value === null || value === void 0 ? void 0 : value.StartTime) + ' - ' + getTime(value === null || value === void 0 ? void 0 : value.EndTime), /*#__PURE__*/ React.createElement(Chip, {
        color: "secondary",
        variant: "filled",
        label: (value === null || value === void 0 ? void 0 : value.AvailabilityCount) + "/" + (value === null || value === void 0 ? void 0 : value.TotalCount),
        size: "small",
        sx: {
            color: 'text.primary',
            ml: 1
        }
    }))); }) : !isSkeleton && dateValue && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        display: 'flex',
        justifyContent: 'center',
        marginTop: "16px"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("No slots available"))))), isSkeleton && dateValue && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        gap: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "medium"
    }, t("Remarks")), /*#__PURE__*/ React.createElement(TextField, {
        id: "reschedule-enter-remarks",
        multiline: true,
        placeholder: t('ENTER_REMARKS_PLACEHOLDER'),
        onChange: function (event) { return handleChangeRejectRemark(event); },
        fullWidth: true,
        rows: 4,
        value: rejectRemark
    })), /*#__PURE__*/ React.createElement(Button, {
        id: "rescheduleAppointmentButton",
        children: t("Reschedule"),
        variant: "contained",
        size: "medium",
        disabled: !(selectedTimeSlot !== null && selectedTimeSlot !== void 0 && selectedTimeSlot.SlotId) || !rejectRemark,
        onClick: onRescheduledClick
    }), /*#__PURE__*/ React.createElement(Button, {
        id: "cancelAppointmentButton",
        children: t("Cancel"),
        size: "small",
        onClick: function () {
            onReschedulePopup(false);
        }
    }));
}
